// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalNew-module__modalInfo--KQQGb>h4 {
   text-align: center;
    font-weight: 400;
    color: #585a5e;
    width: 300px;
    margin: 0 auto;

}
.ModalNew-module__modalInfo--KQQGb>h4>span {
    font-weight: bold;
    color: #0054E6;

}`, "",{"version":3,"sources":["webpack://./src/shared/modal-new/ModalNew.module.css"],"names":[],"mappings":"AAAA;GACG,kBAAkB;IACjB,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,cAAc;;AAElB;AACA;IACI,iBAAiB;IACjB,cAAc;;AAElB","sourcesContent":[".modalInfo>h4 {\r\n   text-align: center;\r\n    font-weight: 400;\r\n    color: #585a5e;\r\n    width: 300px;\r\n    margin: 0 auto;\r\n\r\n}\r\n.modalInfo>h4>span {\r\n    font-weight: bold;\r\n    color: #0054E6;\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalInfo": `ModalNew-module__modalInfo--KQQGb`
};
export default ___CSS_LOADER_EXPORT___;
